import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class webAdvertisementBanner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Exhibitors
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Banner Advertisement
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="ExhibitorsList_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            <span className="position_relative yellow_color">
                                                Banner Advertisement{" "}
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-12">
                                    <div className="custom_table">
                                        <div className="hack1">
                                            <div className="hack2">
                                                <div className="custom_table">
                                                    <div className="hack1">
                                                        <div className="hack2">
                                                            <style
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        "\n                                                    table {\n                                                        border-collapse: collapse;\n                                                        width: 100%;\n                                                    }\n\n                                                    th,\n                                                    td {\n                                                        border: 1px solid #757575;\n                                                        /* solid black border */\n                                                        padding: 15px !important;\n                                                        text-align: center;\n                                                    }\n\n                                                    th {\n                                                        background-color: #f2f2f2;\n                                                    }\n\n                                                    .contact-no {\n                                                        text-align: left;\n                                                    }\n                                                "
                                                                }}
                                                            />
                                                            <table className="table table-dark mg-b-0 advertisement-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                            colSpan={13}
                                                                        >
                                                                            <h6 className="mb-2 my-2 text-dark">
                                                                                Banner Advertisement on INDIA ITME 2026 website
                                                                            </h6>
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <th
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                        >
                                                                            Banner Duration
                                                                        </th>
                                                                        <th colSpan={2}>1 Month</th>
                                                                        <th colSpan={2}>3 Months</th>
                                                                        <th colSpan={2}>6 Months</th>
                                                                        <th colSpan={2}>9 Months</th>
                                                                        <th colSpan={2}>12 Months</th>
                                                                        <th colSpan={2}>15 Months</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                        >
                                                                            Banner Rate Card
                                                                        </td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                        <td>INR</td>
                                                                        <td>USD $</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td />
                                                                        <td>10,000.00</td>
                                                                        <td>$145</td>
                                                                        <td>25,000.00</td>
                                                                        <td>$325</td>
                                                                        <td>50,000.00</td>
                                                                        <td>$620</td>
                                                                        <td>75,000.00</td>
                                                                        <td>$915</td>
                                                                        <td>1,00,000.00</td>
                                                                        <td>$1210</td>
                                                                        <td>1,25,000.00</td>
                                                                        <td>$1500</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                        >
                                                                            Banner Size
                                                                        </td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                        <td colSpan={2}>620 x 120 pixels</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                        >
                                                                            Banner Art Work Format
                                                                        </td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                        <td colSpan={2}>JPG, PNG, PDF</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8" }}
                                                                        >
                                                                            Contact Number
                                                                        </td>
                                                                        <td className="contact-no" colSpan={12}>
                                                                            <a href="tel:+918010823774">
                                                                                +91 80108 23774 &nbsp; |
                                                                            </a>{" "}
                                                                            &nbsp;
                                                                            <a href="tel:+919820507570">+91 98205 07570</a>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            className="text-dark"
                                                                            style={{ backgroundColor: "#e8e8e8 !important" }}
                                                                        >
                                                                            Email Address
                                                                        </td>
                                                                        <td className="contact-no" colSpan={12}>
                                                                            <a href="mailto:itme@india-itme.com">
                                                                                itme@india-itme.com &nbsp; |
                                                                            </a>{" "}
                                                                            &nbsp;{" "}
                                                                            <a href="mailto:projects@india-itme.com">
                                                                                projects@india-itme.com
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(webAdvertisementBanner));